import React from 'react'
import "./DrawerPhotoSpinner.scss";

const DrawerPhotoSpinner = () => <div className="three-quarter-spinner"></div>

export default DrawerPhotoSpinner
